import {mapGetters} from "vuex";

const PageTitle = (defaultTitle) => {
  return {
    computed: {
      ...mapGetters([
        'getMatchingRoute',
      ]),
      pageTitle() {
        const matchedRoute = this.getMatchingRoute(this.$route);

        return matchedRoute
          ? matchedRoute.title
          : defaultTitle;
      },
    }
  }
};

export default PageTitle;
